/** Fired when ScanlineStripe has applied the permutation (Layout home). */
export const STRIPE_COMBINATION_READY_EVENT = "w3s-stripe-combination-ready";

/** sessionStorage key: set after first ready so returning home skips hero hide. */
export const STRIPE_COMBINATION_READY_STORAGE_KEY =
  "w3s-stripe-combination-ready";
